import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "py-4 sm:py-8 sm:p-8" }
const _hoisted_2 = { class: "mb-10 flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "text-sm font-medium text-white" }
const _hoisted_5 = { class: "text-sm font-medium text-white" }
const _hoisted_6 = { class: "text-sm font-medium text-white" }
const _hoisted_7 = { class: "flex flex-wrap gap-2" }
const _hoisted_8 = { class: "flex flex-wrap gap-2" }
const _hoisted_9 = { class: "flex gap-2" }
const _hoisted_10 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_11 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_12 = {
  key: 0,
  class: "space-y-4 md:hidden text-left"
}
const _hoisted_13 = { class: "flex items-center gap-2" }
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = { class: "flex items-center gap-2" }
const _hoisted_16 = { class: "text-white font-bold text-lg" }
const _hoisted_17 = { class: "text-zinc-400 text-xs" }
const _hoisted_18 = { class: "flex flex-col items-end gap-2" }
const _hoisted_19 = { class: "flex items-center gap-1" }
const _hoisted_20 = { class: "grid grid-cols-2 gap-4 mt-2" }
const _hoisted_21 = { class: "flex items-center justify-between pt-4 mt-2 border-t border-white/5" }
const _hoisted_22 = { class: "flex flex-col" }
const _hoisted_23 = { class: "flex gap-2" }
const _hoisted_24 = {
  key: 1,
  class: "text-sm text-white"
}
const _hoisted_25 = {
  key: 2,
  class: "text-sm text-white"
}
const _hoisted_26 = {
  key: 1,
  class: "text-center py-12 text-zinc-500"
}
const _hoisted_27 = { class: "flex items-center gap-2" }
const _hoisted_28 = { class: "grid grid-cols-2 gap-4 py-6" }
const _hoisted_29 = { class: "p-4 rounded-xl bg-white/5 group-hover:bg-primary/10 transition-colors relative z-10" }
const _hoisted_30 = { class: "p-4 rounded-xl bg-white/5 group-hover:bg-primary/10 transition-colors relative z-10" }
const _hoisted_31 = { class: "flex items-center gap-3" }
const _hoisted_32 = { class: "p-2.5 rounded-xl bg-primary/10 border border-primary/20" }
const _hoisted_33 = { class: "flex-1 overflow-hidden flex flex-col items-center" }
const _hoisted_34 = { class: "w-full px-12 py-8 bg-zinc-900/20 border-b border-zinc-800" }
const _hoisted_35 = { class: "flex flex-col items-center text-center gap-1" }
const _hoisted_36 = { class: "flex-1 w-full overflow-y-auto custom-scrollbar" }
const _hoisted_37 = { class: "max-w-5xl mx-auto px-8 py-10 h-full" }
const _hoisted_38 = {
  key: 0,
  class: "animate-in fade-in slide-in-from-right-4 duration-500"
}
const _hoisted_39 = { class: "grid lg:grid-cols-[1fr,360px] gap-12" }
const _hoisted_40 = { class: "space-y-8" }
const _hoisted_41 = { class: "space-y-3" }
const _hoisted_42 = { class: "flex items-center gap-2" }
const _hoisted_43 = {
  key: 0,
  class: "space-y-4 p-6 rounded-2xl bg-primary/5 border border-primary/10"
}
const _hoisted_44 = { class: "flex items-center gap-3 mb-2" }
const _hoisted_45 = {
  key: 1,
  class: "space-y-6"
}
const _hoisted_46 = { class: "space-y-3" }
const _hoisted_47 = { class: "space-y-3" }
const _hoisted_48 = { class: "grid md:grid-cols-2 gap-6 pt-4" }
const _hoisted_49 = { class: "space-y-3" }
const _hoisted_50 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_51 = { class: "space-y-3" }
const _hoisted_52 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_53 = { class: "hidden lg:block relative" }
const _hoisted_54 = { class: "sticky top-0 space-y-4" }
const _hoisted_55 = { class: "flex items-center justify-between px-2" }
const _hoisted_56 = { class: "p-1 rounded-[2.5rem] bg-zinc-900 border border-zinc-800 shadow-2xl overflow-hidden aspect-[9/16] max-h-[560px]" }
const _hoisted_57 = { class: "h-full w-full rounded-[2.2rem] overflow-hidden bg-black/40 relative" }
const _hoisted_58 = {
  key: 1,
  class: "max-w-4xl mx-auto space-y-10 animate-in fade-in slide-in-from-right-4 duration-500"
}
const _hoisted_59 = { class: "grid md:grid-cols-2 gap-4" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "flex items-start gap-4 z-10 relative" }
const _hoisted_62 = { class: "flex-1" }
const _hoisted_63 = { class: "text-xs text-zinc-500 mt-1 leading-relaxed" }
const _hoisted_64 = {
  key: 0,
  class: "animate-in zoom-in duration-300"
}
const _hoisted_65 = {
  key: 0,
  class: "flex items-center justify-center gap-2 text-sm font-medium"
}
const _hoisted_66 = { class: "text-white" }
const _hoisted_67 = { class: "text-zinc-400" }
const _hoisted_68 = {
  key: 1,
  class: "space-y-6 p-8 rounded-3xl bg-zinc-900 border border-zinc-800 animate-in slide-in-from-top-4 duration-500"
}
const _hoisted_69 = { class: "space-y-4" }
const _hoisted_70 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_71 = { class: "text-[10px] text-gray-400" }
const _hoisted_72 = {
  key: 2,
  class: "space-y-6 p-8 rounded-3xl bg-zinc-900 border border-zinc-800 animate-in slide-in-from-top-4 duration-500"
}
const _hoisted_73 = { class: "space-y-4" }
const _hoisted_74 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_75 = { class: "flex items-center justify-between p-4 rounded-xl bg-white/5 border border-white/5" }
const _hoisted_76 = { class: "space-y-1" }
const _hoisted_77 = {
  key: 3,
  class: "space-y-6 p-8 rounded-3xl bg-zinc-900 border border-zinc-800 animate-in slide-in-from-top-4 duration-500"
}
const _hoisted_78 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_79 = {
  key: 2,
  class: "max-w-xl mx-auto space-y-10 animate-in fade-in slide-in-from-right-4 duration-500"
}
const _hoisted_80 = {
  key: 0,
  class: "space-y-6"
}
const _hoisted_81 = { class: "p-8 rounded-3xl bg-zinc-900 border border-zinc-800 space-y-6" }
const _hoisted_82 = { class: "flex items-center gap-3" }
const _hoisted_83 = {
  key: 1,
  class: "space-y-8"
}
const _hoisted_84 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_85 = {
  key: 0,
  class: "space-y-6 animate-in slide-in-from-top-4 duration-500"
}
const _hoisted_86 = { class: "p-6 rounded-2xl bg-zinc-900 border border-zinc-800 space-y-4" }
const _hoisted_87 = { class: "p-6 rounded-2xl bg-zinc-900 border border-zinc-800 space-y-4" }
const _hoisted_88 = { class: "flex items-center gap-2" }
const _hoisted_89 = { class: "flex items-center gap-4" }
const _hoisted_90 = { class: "flex-1" }
const _hoisted_91 = { class: "p-1 rounded-2xl bg-zinc-800" }
const _hoisted_92 = { class: "p-6 rounded-[calc(1rem-1px)] bg-zinc-950 space-y-6" }
const _hoisted_93 = { class: "flex items-center justify-between" }
const _hoisted_94 = { class: "space-y-1" }
const _hoisted_95 = {
  key: 0,
  class: "space-y-4 pt-4 border-t border-zinc-800 animate-in slide-in-from-top-2"
}
const _hoisted_96 = { class: "flex items-center gap-3" }
const _hoisted_97 = { class: "flex items-center gap-3" }
const _hoisted_98 = {
  key: 0,
  class: "grid grid-cols-2 gap-6 py-4 text-white"
}
const _hoisted_99 = { class: "col-span-full text-white grid grid-cols-4 justify-between items-center gap-y-6" }
const _hoisted_100 = {
  key: 0,
  class: "flex justify-center items-center gap-2 flex-col"
}
const _hoisted_101 = { class: "text-sm" }
const _hoisted_102 = { class: "flex justify-center items-center gap-2 flex-col" }
const _hoisted_103 = { class: "text-sm" }
const _hoisted_104 = { class: "flex justify-center items-center gap-2 flex-col" }
const _hoisted_105 = { class: "text-sm" }
const _hoisted_106 = { class: "flex justify-center items-center gap-2 flex-col" }
const _hoisted_107 = { class: "text-sm" }
const _hoisted_108 = {
  key: 1,
  class: "flex justify-center items-center gap-2 flex-col"
}
const _hoisted_109 = { class: "text-sm" }
const _hoisted_110 = {
  key: 2,
  class: "flex justify-center items-center gap-2 flex-col"
}
const _hoisted_111 = { class: "text-sm" }

import { ref, onMounted, watch, computed } from 'vue'
import { watchDebounced } from '@vueuse/core'
import {
  ArrowsUpDownIcon,
  TrashIcon,
} from '@heroicons/vue/24/outline'
import MobileCard from '@/components/ui/mobile-card/MobileCard.vue'
import MobileDataLabel from '@/components/ui/mobile-card/MobileDataLabel.vue'
import {
  Dialog,
  DialogScrollContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { Badge } from '@/components/ui/badge'
import RegisterButton from '@/components/ui/register-button/RegisterButton.vue'
import Table from '@/components/ui/table/Table.vue'
import TableCell from '@/components/ui/table/TableCell.vue'
import TableFallback from '@/components/ui/table/TableFallback.vue'
import TableRow from '@/components/ui/table/TableRow.vue'
import TableBody from '@/components/ui/table/TableBody.vue'
import TableHeader from '@/components/ui/table/TableHeader.vue'
import TableHead from '@/components/ui/table/TableHead.vue'
import TableContainer from '@/components/ui/table/TableContainer.vue'
import { CreateMessageDTO, GetAllMessagesParams, UpdateMessageDTO, useMessage } from '@/composables/useMessage'
import { Message } from '@/interfaces/messages/Message'
import { Pagination as IPagination } from '@/interfaces/Pagination'
import TableRowSkeleton from '@/components/ui/table/TableRowSkeleton.vue'
import { CalendarIcon, CircleHelp, Contact, Eye, GitMerge, Hourglass, Loader2, MessageSquareMore, MessageSquareShare, PencilIcon, Send, X } from 'lucide-vue-next'
import { useToast } from '@/components/ui/toast'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import PageTitle from '@/components/ui/page/PageTitle.vue'
import PageDescription from '@/components/ui/page/PageDescription.vue'
import AnyFileUpload from '@/components/ui/upload/AnyFileUpload.vue'
import { MessageRecipientTypeEnum, MessageRecipientTypeLabels } from '@/enums/messages/MessageRecipientTypeEnum'
import { Switch } from '@/components/ui/switch'
import { CalendarTime } from '@/components/ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { MessageStatusEnum } from '@/enums/messages/MessageStatusEnum'
import TimePicker from '@/components/ui/time/TimePicker.vue'
import DeleteConfirmationDialog from '@/components/ui/delete-dialog/DeleteConfirmationDialog.vue'
import { useTime } from '@/composables/useTime'
import { ComboboxAnchor, ComboboxContent, ComboboxInput, ComboboxPortal, ComboboxRoot } from 'radix-vue'
import { PaymentPlan } from '@/interfaces/PaymentPlan'
import { CommandEmpty, CommandGroup, CommandItem, CommandList } from '@/components/ui/command'
import { TagsInput, TagsInputInput, TagsInputItem, TagsInputItemDelete, TagsInputItemText } from '@/components/ui/tags-input'
import { usePaymentPlan } from '@/composables/usePaymentPlan'
import { useButton } from '@/composables/useButton'
import { Button as IButton } from '@/interfaces/Button'
import TelegramMessagePreview, { MessagePreviewProp } from '@/components/ui/telegram/TelegramMessagePreview.vue'
import { MessageMediaPlacementEnum } from '@/enums/messages/media/MessageMediaPlacementEnum'
import { useBot } from '@/composables/useBot'
import { PaymentPlanStatusEnum } from '@/enums/payment-plans/PaymentPlanStatusEnum'
import { useGroup } from '@/composables/useGroup'
import { Group } from '@/interfaces/Group'
import { useRoute } from 'vue-router'
import router from '@/router'
import MessageRecipientTypeBadge from '@/components/ui/badge/MessageRecipientTypeBadge.vue'
import { useFlow } from '@/composables/chatFlow/useFlow'
import { NodeTypeEnum, NodeTypeLabels } from '@/enums/chatFlow/nodes/NodeTypeEnum'
import { BotTypeEnum } from '@/enums/bots/BotTypeEnum'
import { Flow } from '@/interfaces/chat-flow/flow/Flow'
import { Info, MessageSquareText, Layout, Users, Rocket, Check, ArrowRight, ArrowLeft, HelpCircle } from 'lucide-vue-next'
import RichTextarea from '@/components/ui/textarea/RichTextarea.vue'
import {
  Stepper,
  StepperItem,
  StepperTrigger,
  StepperSeparator,
  StepperTitle,
  StepperDescription,
  StepperIndicator
} from '@/components/ui/stepper'


export default /*@__PURE__*/_defineComponent({
  __name: 'ManageMessagesView',
  setup(__props) {

const { selectedBot } = useBot()
const { toast } = useToast()
const route = useRoute()
const { create, getAll, getById, update, destroy, countRecipients } = useMessage()

// Stepper Logic
const currentStep = ref(1)
const steps = [
  { step: 1, title: 'Criar', description: 'Conteúdo do disparo', icon: Layout },
  { step: 2, title: 'Público', description: 'Quem deve ver', icon: Users },
  { step: 3, title: 'Enviar', description: 'Data e regras', icon: Rocket },
]

const isStep1Valid = computed(() => {
  const hasName = !!messageForm.value.description
  const hasContent = creationMode.value === 'flow' ? !!messageForm.value.flowId : (!!messageForm.value.message || !!messageForm.value.startMedia || !!startMediaPreview.value)
  return hasName && hasContent
})

const isStep2Valid = computed(() => {
  if (!messageForm.value.recipientType) return false
  if (messageForm.value.recipientType === MessageRecipientTypeEnum.DOWNSELL) {
     return (messageForm.value.downsellPaymentPlanIds?.length ?? 0) > 0 || messageForm.value.abandonedChat
  }
  return true
})

const isStep3Valid = computed(() => {
  if (messageForm.value.recipientType === MessageRecipientTypeEnum.DOWNSELL) return !!sendingIntervalTime.value
  const scheduleValid = dispatchNow.value || !!messageForm.value.sendAt
  const repetitionValid = dispatchOnce.value || !!messageForm.value.sendingInterval
  return scheduleValid && repetitionValid
})

const isStepValid = computed(() => {
  if (currentStep.value === 1) return isStep1Valid.value
  if (currentStep.value === 2) return isStep2Valid.value
  if (currentStep.value === 3) return isStep3Valid.value
  return false
})

const isStepDisabled = (step: number) => {
  if (editingMessage.value) return false // Allow all if editing
  if (step === 1) return false
  if (step === 2) return !isStep1Valid.value
  if (step === 3) return !isStep1Valid.value || !isStep2Valid.value
  return true
}


const { formatInterval } = useTime()
const startMediaPreview = ref()
const startMediaPreviewType = ref()
// Table Configuration
const tableHeaders = [
  { key: 'sendAt', label: 'Envio', sortable: false },
  { key: 'description', label: 'Descrição', sortable: false },
  { key: 'recipient', label: 'Destinatário', sortable: false },
  { key: 'successCount', label: 'Sucesso', sortable: false },
  { key: 'failureCount', label: 'Falha', sortable: false },
  { key: 'status', label: 'Status', sortable: false },
  { key: 'actions', label: 'Ações', class: 'opacity-0', sortable: false },
]
const isSaving = ref(false)
const perPage = ref('10')
const messageFormPreview = computed(() => {
  const messages = []

  if (creationMode.value === 'flow' && messageForm.value.flowId) {
    const selectedFlow = flowsOptions.value.find(f => String(f.id) === String(messageForm.value.flowId))
    if (selectedFlow) {
      messages.push({
        type: 'flow' as const,
        text: selectedFlow.name,
        description: selectedFlow.description || 'Este fluxo iniciará automaticamente para o lead.'
      })
    }
  }

  const startMedia = messageForm.value.startMedia
  const paymentPlansPreview =  paymentPlans.value?.data.filter(i => messageForm.value.paymentPlanIds?.includes(String(i.id)))
  const buttonsPreview =  buttons.value?.data.filter(i => messageForm.value.buttonIds?.includes(String(i.id)))

  if (startMedia) {
    messages.push({
      type: startMedia?.type.split('/')[0] as any,
      source: URL.createObjectURL(startMedia)
    })
  } else if (startMediaPreview.value) {
    messages.push({
      type: startMediaPreviewType.value,
      source: startMediaPreview.value
    })
  }

  if (messageForm.value.message) {
    messages.push({
      type: 'text' as const,
      text: messageForm.value.message
    })
  }

  messages.push(
    ...(paymentPlansPreview ?? []).map(plan => ({
      type: 'button' as const,
      text: plan.buttonMessage
    })),
    ...(buttonsPreview ?? []).map(button => ({
      type: 'button' as const,
      isRedirectLink: true,
      text: button.name
    }))
  )

  return messages
})
const previewMessages = computed(() => {
  const messages: MessagePreviewProp[] = []

  if (selectedMessage.value?.flowId) {
    messages.push({
      type: 'flow',
      text: selectedMessage.value.description // Use description as flow name for existing messages
    })
  }

  const startMedia = selectedMessage.value?.media?.find(media => media.placement === MessageMediaPlacementEnum.START)

  if (startMedia) {
    messages.push({
      type: startMedia?.type as any,
      source: startMedia.source
    })
  }

  messages.push({
      type: 'text',
      text: selectedMessage.value?.message
    },
    ...(selectedMessage.value?.paymentPlans ?? []).map(plan => ({
      type: 'button' as const,
      text: plan.buttonMessage
    })),
    ...(selectedMessage.value?.buttons ?? []).map(button => ({
      type: 'button' as const,
      isRedirectLink: true,
      text: button.name
    }))
  )

  return messages
})

// Filters
const dispatchNow = ref(true)
const dispatchOnce = ref(true)
// Messages data (empty for demo)
const messages = ref<IPagination<Message>>()
// Modal and Form
const isMessageModalOpen = ref(false)
const editingMessage = ref<Message | null>(null)
const messageForm = ref<Partial<CreateMessageDTO>>({
  hasSpoiler: false
})
const deletingMessage = ref<number>()
const isDeleteMessageDialogOpen = ref(false)
const isDeletingMessage = ref(false)
const sendingIntervalTime = ref()
const selectedMessage = ref<Message>()
const isShowMessageDialogOpen = ref(false)
const isLoadingMessage = ref(false)
const isChoiceModalOpen = ref(false)
const creationMode = ref<'standard' | 'flow' | null>(null)
const { intervalToHHMM, convertIntervalToMinutes, convertIntervalToDays } = useTime()

const { getAll: getAllPaymentPlans } = usePaymentPlan()
const paymentPlans = ref<IPagination<PaymentPlan>>()
const filteredPaymentPlans = computed(() => paymentPlans.value?.data.filter(i => !messageForm.value.paymentPlanIds?.includes(String(i.id)) && i.status !== PaymentPlanStatusEnum.INACTIVE))
const searchPaymentPlan = ref('')
const isPaymentPlanComboboxOpen = ref(false)
const paymentPlanNames = ref<string[]>([])

const filteredDownsellPaymentPlans = computed(() => paymentPlans.value?.data.filter(i => !messageForm.value.downsellPaymentPlanIds?.includes(String(i.id)) && i.status !== PaymentPlanStatusEnum.INACTIVE))
const searchDownsellPaymentPlan = ref('')
const isDownsellPaymentPlanComboboxOpen = ref(false)
const downsellPaymentPlanNames = ref<string[]>([])

const filteredTargetPaymentPlans = computed(() => paymentPlans.value?.data.filter(i => !messageForm.value.targetPaymentPlanIds?.includes(String(i.id)) && i.status !== PaymentPlanStatusEnum.INACTIVE))
const searchTargetPaymentPlan = ref('')
const isTargetPaymentPlanComboboxOpen = ref(false)
const targetPaymentPlanNames = ref<string[]>([])

const UNCOUNTABLE_RECIPIENT_TYPES = [MessageRecipientTypeEnum.DOWNSELL, MessageRecipientTypeEnum.CHAT_JOIN_REQUEST_APPROVAL]
const recipientCount = ref<number | null>(null)
const isLoadingRecipientCount = ref(false)

watchDebounced(
  () => [
    messageForm.value.recipientType,
    messageForm.value.targetPaymentPlanIds?.join(','),
    messageForm.value.flowId,
    messageForm.value.nodeId
  ],
  async () => {
    const recipientType = messageForm.value.recipientType

    if (!recipientType || UNCOUNTABLE_RECIPIENT_TYPES.includes(recipientType)) {
      recipientCount.value = null
      return
    }

    if ((recipientType === MessageRecipientTypeEnum.FLOW_NODE || recipientType === MessageRecipientTypeEnum.FLOW_CURRENT_NODE) && (!messageForm.value.flowId || !messageForm.value.nodeId)) {
      recipientCount.value = null
      return
    }

    isLoadingRecipientCount.value = true
    try {
      recipientCount.value = await countRecipients({
        recipientType,
        targetPaymentPlanIds: messageForm.value.targetPaymentPlanIds,
        flowId: messageForm.value.flowId,
        nodeId: messageForm.value.nodeId
      })
    } catch {
      recipientCount.value = null
    } finally {
      isLoadingRecipientCount.value = false
    }
  },
  { debounce: 400, immediate: true }
)

const { getAll: getAllButtons } = useButton()
const buttons = ref<IPagination<IButton>>()
const filteredButtons = computed(() => buttons.value?.data.filter(i => !messageForm.value.buttonIds?.includes(String(i.id))))
const searchButton = ref('')
const isButtonComboboxOpen = ref(false)
const buttonNames = ref<string[]>([])

const { getAll: getAllGroups } = useGroup()
const groups = ref<IPagination<Group>>()
const filteredGroups = computed(() => groups.value?.data.filter(i => !messageForm.value.groupIds?.includes(String(i.id))))
const searchGroup = ref('')
const isGroupComboboxOpen = ref(false)
const groupNames = ref<string[]>([])

const { getById: getFlowById, getAll: getAllFlows } = useFlow()
const flowsOptions = ref<Flow[]>([])
const flow = ref()
const node = computed(() => {
  if (flow.value && route.query.nodeId) {
    return flow.value.definition.nodes.find((node: any) => node.id === route.query.nodeId)
  }
  return null
})

// Actions
const openNewMessageModal = () => {
  if (selectedBot.value?.type === BotTypeEnum.CHAT_FLOW) {
    isChoiceModalOpen.value = true
    return
  }

  selectMessageType('standard')
}

const selectMessageType = (type: 'standard' | 'flow') => {
  creationMode.value = type
  isChoiceModalOpen.value = false
  
  dispatchNow.value = true
  sendingIntervalTime.value = undefined
  startMediaPreview.value = undefined
  isPaymentPlanComboboxOpen.value = false
  isButtonComboboxOpen.value = false
  isGroupComboboxOpen.value = false
  isDownsellPaymentPlanComboboxOpen.value = false
  searchPaymentPlan.value = ''
  searchDownsellPaymentPlan.value = ''
  searchButton.value = ''
  searchGroup.value = ''
  paymentPlanNames.value = []
  downsellPaymentPlanNames.value = []
  targetPaymentPlanNames.value = []
  buttonNames.value = []
  groupNames.value = []
  editingMessage.value = null
  messageForm.value = { paymentPlanIds: [], buttonIds: [], groupIds: [], downsellPaymentPlanIds: [], targetPaymentPlanIds: [], hasSpoiler: false }
  isMessageModalOpen.value = true
  currentStep.value = 1
}

const closeMessageModal = () => {
  isMessageModalOpen.value = false
  currentStep.value = 1
}

const showMessage = async (id: number) => {
  selectedMessage.value = undefined
  isShowMessageDialogOpen.value = true
  selectedMessage.value = await getById(id)
}
const editMessage = async (message: Message) => {
  // editingMessage.value = message.id
  // const delayInSeconds = message.newMembersAcceptanceDelay ? convertIntervalToSeconds(message.newMembersAcceptanceDelay) : 0
  // const { value: newMembersAcceptanceDelay, unit } = convertFromSeconds(delayInSeconds);

  // timeUnit.value = unit;
  // messageForm.value = {
  //   name: message.name,
  //   messageId: message.messageId,
  //   category: message.category,
  //   newMembersAcceptanceDelay,
  // }
  startMediaPreview.value = undefined
  isMessageModalOpen.value = true
  currentStep.value = 1
  isLoadingMessage.value = true
  editingMessage.value = await getById(message.id)
  isLoadingMessage.value = false

  creationMode.value = editingMessage.value.flowId ? 'flow' : 'standard'

  messageForm.value = {
    description: editingMessage.value.description,
    message: editingMessage.value.message,
    paymentPlanIds: editingMessage.value.paymentPlans?.map(p => p.id.toString()),
    buttonIds: editingMessage.value.buttons?.map(b => b.id.toString()),
    groupIds: editingMessage.value.groups?.map(g => g.id.toString()),
    downsellPaymentPlanIds: editingMessage.value.downsellPaymentPlans?.map(p => p.id.toString()),
    targetPaymentPlanIds: editingMessage.value.targetPaymentPlans?.map(p => p.id.toString()),
    recipientType: editingMessage.value.recipientType,
    sendingRange: editingMessage.value.sendingRange ? convertIntervalToMinutes(editingMessage.value.sendingRange) : undefined,
    sendAt: editingMessage.value.sendAt ? new Date(editingMessage.value.sendAt) : undefined,
    sendingInterval: editingMessage.value.sendingInterval && editingMessage.value.recipientType !== MessageRecipientTypeEnum.DOWNSELL ? convertIntervalToDays(editingMessage.value.sendingInterval) : editingMessage.value.sendingInterval as number,
    abandonedChat: editingMessage.value.abandonedChat,
    flowId: editingMessage.value.flowId ? String(editingMessage.value.flowId) : undefined,
    hasSpoiler: editingMessage.value.media?.find(m => m.placement === MessageMediaPlacementEnum.START)?.hasSpoiler ?? false,
  }
  if (messageForm.value.sendingInterval) {
    dispatchOnce.value = false
    dispatchNow.value = false
  } else {
    dispatchOnce.value = true
    dispatchNow.value = true
  }
  const startMedia = editingMessage.value.media?.find(m => m.placement === MessageMediaPlacementEnum.START)
  if (startMedia) {
    startMediaPreview.value = startMedia.source
    startMediaPreviewType.value = startMedia.type
  }
  sendingIntervalTime.value = editingMessage.value.sendingInterval ? intervalToHHMM(editingMessage.value.sendingInterval) : undefined
  paymentPlanNames.value = editingMessage.value.paymentPlans?.map(p => p.name) ?? []
  buttonNames.value = editingMessage.value.buttons?.map(b => b.name) ?? []
  groupNames.value = editingMessage.value.groups?.map(g => g.name) ?? []
  downsellPaymentPlanNames.value = editingMessage.value.downsellPaymentPlans?.map(p => p.name) ?? []
  targetPaymentPlanNames.value = editingMessage.value.targetPaymentPlans?.map(p => p.name) ?? []
}

const deleteMessage = (message: any) => {
  isDeleteMessageDialogOpen.value = true
  deletingMessage.value = message.id
}

const sortBy = (key: string) => {
  // Implement sorting logic
}

const save = async () => {
  isSaving.value = true

  try {
    let payload = { ...messageForm.value }

    if (payload.flowId) {
      payload.flowId = Number(payload.flowId)
    }

    if (dispatchNow.value || payload.recipientType === MessageRecipientTypeEnum.DOWNSELL) {
      delete payload.sendAt
      delete payload.sendingRange
    }

    if (dispatchOnce.value || !payload.sendingInterval) {
      payload.sendingInterval = null
    }

    if (payload.sendingRange) {
      payload.sendingRange = payload.sendingRange * 60
    }

    if (payload.sendingInterval) {
      payload.sendingInterval = payload.sendingInterval * 24 * 60 * 60
    }

    if (payload.recipientType === MessageRecipientTypeEnum.DOWNSELL) {
      const [hours, minutes] = sendingIntervalTime.value.split(':').map(Number)
      payload.sendingInterval = (hours * 60 * 60) + (minutes * 60)
    }

    payload.abandonedChat = !!payload.abandonedChat

    const { 
      paymentPlanIds, 
      buttonIds, 
      groupIds, 
      downsellPaymentPlanIds, 
      targetPaymentPlanIds,
      ...cleanPayload 
    } = payload

    if (!editingMessage.value) {
      const message = await create(cleanPayload as CreateMessageDTO, paymentPlanIds as any, buttonIds as any, groupIds as any, downsellPaymentPlanIds as any, targetPaymentPlanIds as any)
      toast({
        title: 'Mensagem criada com sucesso',
        class: 'bg-green-500 text-white',
        duration: 1500
      })
      messages.value?.data.push({ ...message, successCount: 0, failureCount: 0 })
    } else {
      delete (cleanPayload as any).recipientType
      const message = await update(editingMessage.value.id, cleanPayload as UpdateMessageDTO, paymentPlanIds as any, buttonIds as any, groupIds as any, downsellPaymentPlanIds as any, targetPaymentPlanIds as any)
      toast({
        title: 'Mensagem editada com sucesso',
        class: 'bg-green-500 text-white',
        duration: 1500
      })
      const index = messages.value?.data.findIndex(message => message.id == editingMessage.value!.id)
      if (index !== -1) {
        messages.value!.data[index!] = { ...message, ...editingMessage.value, ...messageForm.value } as unknown as Message
      }
    }

    isMessageModalOpen.value = false
  } finally {
    isSaving.value = false
  }
}

function reloadAndGetAll(params: GetAllMessagesParams) {
  messages.value = undefined
  getAll(params)
    .then(data => messages.value = data)
}

watch(() => perPage.value, () => {
  reloadAndGetAll({ perPage: perPage.value })
})

watch(() => isMessageModalOpen.value, () => {
  if (!paymentPlans.value) {
    getAllPaymentPlans({ perPage: '50' })
      .then((data) => {
        paymentPlans.value = data
        if (route.query.recipientType === MessageRecipientTypeEnum.DOWNSELL && route.query.downsellPaymentPlanIds) {
          messageForm.value.recipientType = MessageRecipientTypeEnum.DOWNSELL
          const paymentPlan = paymentPlans.value?.data.find(plan => plan.id == (route.query.downsellPaymentPlanIds as unknown as number))
          downsellPaymentPlanNames.value = [paymentPlan?.name ?? '']
          messageForm.value.downsellPaymentPlanIds = [route.query.downsellPaymentPlanIds]
        }
      })
  }
  if (!buttons.value) {
    getAllButtons()
      .then((data) => buttons.value = data)
  }

  if (selectedBot.value?.type === BotTypeEnum.CHAT_FLOW && flowsOptions.value.length === 0) {
    getAllFlows({ perPage: '100' }).then(data => flowsOptions.value = data.data)
  }

  if (!isMessageModalOpen.value) {
    flow.value = undefined
    router.replace({
      query: {}
    })
  }
})

watch(() => messageForm.value.recipientType, async () => {
  if (messageForm.value.recipientType === MessageRecipientTypeEnum.CHAT_JOIN_REQUEST_APPROVAL && !groups.value) {
    groups.value = await getAllGroups({ perPage: '50' })
  }
})

onMounted(() => {
  getAll()
    .then((data) => messages.value = data)

  if ((route.query.recipientType === MessageRecipientTypeEnum.DOWNSELL && route.query.downsellPaymentPlanIds) || (route.query.flowId && route.query.nodeId)) {
    openNewMessageModal()
    if (route.query.flowId && route.query.nodeId) {
      getFlowById(Number(route.query.flowId))
        .then((data) => {
          flow.value = data
          messageForm.value.recipientType = MessageRecipientTypeEnum.FLOW_NODE
          messageForm.value.flowId = Number(route.query.flowId)
          messageForm.value.nodeId = route.query.nodeId as string
        })
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(PageTitle, null, {
            default: _withCtx(() => _cache[56] || (_cache[56] = [
              _createTextVNode(" Disparo de mensagens ")
            ])),
            _: 1
          }),
          _createVNode(PageDescription, null, {
            default: _withCtx(() => _cache[57] || (_cache[57] = [
              _createTextVNode(" Envie mensagens automatizadas e personalizadas para impulsionar suas vendas. ")
            ])),
            _: 1
          })
        ]),
        _createVNode(RegisterButton, { onClick: openNewMessageModal }, {
          default: _withCtx(() => _cache[58] || (_cache[58] = [
            _createTextVNode("Disparar mensagem")
          ])),
          _: 1
        })
      ]),
      _createVNode(TableContainer, null, {
        default: _withCtx(() => [
          _cache[62] || (_cache[62] = _createElementVNode("div", { class: "mb-6 flex items-center justify-between" }, [
            _createElementVNode("h2", { class: "text-xl font-semibold text-white" }, "Mensagens disparadas")
          ], -1)),
          _createVNode(Table, { class: "hidden md:block" }, {
            default: _withCtx(() => [
              _createVNode(TableHeader, null, {
                default: _withCtx(() => [
                  _createVNode(TableRow, null, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableHeaders, (header) => {
                        return _createVNode(TableHead, {
                          key: header.key,
                          class: _normalizeClass(header.class)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createTextVNode(_toDisplayString(header.label) + " ", 1),
                              (header.sortable)
                                ? (_openBlock(), _createBlock(_unref(ArrowsUpDownIcon), {
                                    key: 0,
                                    class: "h-4 w-4 cursor-pointer text-gray-500 hover:text-white",
                                    onClick: ($event: any) => (sortBy(header.key))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["class"])
                      }), 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(TableBody, null, {
                default: _withCtx(() => [
                  (messages.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (messages.value.data.length === 0)
                          ? (_openBlock(), _createBlock(TableFallback, {
                              key: 0,
                              colspan: tableHeaders.length,
                              icon: _unref(MessageSquareMore),
                              title: "Nenhuma mensagem encontrada",
                              description: `Clique em 'Disparar mensagem' para começar`
                            }, null, 8, ["colspan", "icon"]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value.data, (message) => {
                          return (_openBlock(), _createBlock(TableRow, {
                            key: message.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_4, _toDisplayString(new Date(message.sendAt).toLocaleString()), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_5, _toDisplayString(message.description), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_6, [
                                      _createVNode(MessageRecipientTypeBadge, {
                                        recipient: message.recipientType
                                      }, null, 8, ["recipient"])
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_unref(Badge), { variant: "default" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(message.successCount), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_unref(Badge), { variant: "destructive" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(message.failureCount), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_9, [
                                    (message.sendingInterval || message.recipientType === _unref(MessageRecipientTypeEnum).CHAT_JOIN_REQUEST_APPROVAL)
                                      ? (_openBlock(), _createBlock(_unref(Switch), {
                                          key: 0,
                                          checked: message.status === _unref(MessageStatusEnum).ACTIVE,
                                          "onUpdate:checked": (status) => {
                      message.status = status ? _unref(MessageStatusEnum).ACTIVE : _unref(MessageStatusEnum).INACTIVE
                      _unref(update)(message.id, { status: status ? _unref(MessageStatusEnum).ACTIVE : _unref(MessageStatusEnum).INACTIVE }).then(() => {
                        _unref(toast)({
                          title: 'Status da mensagem atualizado',
                          class: 'bg-green-500 text-white',
                          duration: 1500
                        })
                      })
                    }
                                        }, null, 8, ["checked", "onUpdate:checked"]))
                                      : (message.successCount > 0 || message.failureCount > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Disparado"))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_11, "Pendente"))
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  (message.sendingInterval || message.recipientType === _unref(MessageRecipientTypeEnum).CHAT_JOIN_REQUEST_APPROVAL)
                                    ? (_openBlock(), _createBlock(_unref(Button), {
                                        key: 0,
                                        variant: "ghost",
                                        size: "icon",
                                        onClick: ($event: any) => (editMessage(message))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(PencilIcon), { class: "h-4 w-4" })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_unref(Button), {
                                    variant: "ghost",
                                    size: "icon",
                                    class: "",
                                    onClick: ($event: any) => (showMessage(message.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Eye), { class: "h-4 w-4" })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_unref(Button), {
                                    variant: "ghost",
                                    size: "icon",
                                    class: "hover:text-red-400",
                                    onClick: ($event: any) => (deleteMessage(message))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(TrashIcon), { class: "h-4 w-4" })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ], 64))
                    : (_openBlock(), _createBlock(TableRowSkeleton, {
                        key: 1,
                        columns: tableHeaders.length
                      }, null, 8, ["columns"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (messages.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (messages.value.data.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(messages.value.data, (message) => {
                      return (_openBlock(), _createBlock(MobileCard, {
                        key: message.id
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _cache[59] || (_cache[59] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider" }, "Disparo", -1)),
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("span", _hoisted_16, _toDisplayString(new Date(message.sendAt).toLocaleDateString()), 1),
                                _createElementVNode("span", _hoisted_17, _toDisplayString(new Date(message.sendAt).toLocaleTimeString()), 1)
                              ])
                            ])
                          ])
                        ]),
                        actions: _withCtx(() => [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              (message.sendingInterval || message.recipientType === _unref(MessageRecipientTypeEnum).CHAT_JOIN_REQUEST_APPROVAL)
                                ? (_openBlock(), _createBlock(_unref(Button), {
                                    key: 0,
                                    variant: "ghost",
                                    size: "icon",
                                    class: "h-8 w-8 text-zinc-400 hover:text-white",
                                    onClick: ($event: any) => (editMessage(message))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(PencilIcon), { class: "h-4 w-4" })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode(_unref(Button), {
                                variant: "ghost",
                                size: "icon",
                                class: "h-8 w-8 text-zinc-400 hover:text-white",
                                onClick: ($event: any) => (showMessage(message.id))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Eye), { class: "h-4 w-4" })
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_unref(Button), {
                                variant: "ghost",
                                size: "icon",
                                class: "h-8 w-8 text-zinc-400 hover:text-red-400",
                                onClick: ($event: any) => (deleteMessage(message))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(TrashIcon), { class: "h-4 w-4" })
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ])
                        ]),
                        content: _withCtx(() => [
                          _createVNode(MobileDataLabel, { label: "Descrição" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(message.description), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(MobileDataLabel, { label: "Destinatário" }, {
                            default: _withCtx(() => [
                              _createVNode(MessageRecipientTypeBadge, {
                                recipient: message.recipientType
                              }, null, 8, ["recipient"])
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(MobileDataLabel, { label: "Sucesso" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Badge), { variant: "default" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(message.successCount), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(MobileDataLabel, { label: "Falha" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Badge), { variant: "destructive" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(message.failureCount), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _cache[60] || (_cache[60] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider mb-1" }, "Status", -1)),
                              _createElementVNode("div", _hoisted_23, [
                                (message.sendingInterval || message.recipientType === _unref(MessageRecipientTypeEnum).CHAT_JOIN_REQUEST_APPROVAL)
                                  ? (_openBlock(), _createBlock(_unref(Switch), {
                                      key: 0,
                                      checked: message.status === _unref(MessageStatusEnum).ACTIVE,
                                      "onUpdate:checked": (status) => {
                          message.status = status ? _unref(MessageStatusEnum).ACTIVE : _unref(MessageStatusEnum).INACTIVE
                          _unref(update)(message.id, { status: status ? _unref(MessageStatusEnum).ACTIVE : _unref(MessageStatusEnum).INACTIVE }).then(() => {
                            _unref(toast)({
                              title: 'Status da mensagem atualizado',
                              class: 'bg-green-500 text-white',
                              duration: 1500
                            })
                          })
                        }
                                    }, null, 8, ["checked", "onUpdate:checked"]))
                                  : (message.successCount > 0 || message.failureCount > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Disparado"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_25, "Pendente"))
                              ])
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createVNode(_unref(MessageSquareMore), { class: "size-8 mx-auto mb-3 text-zinc-700" }),
                      _cache[61] || (_cache[61] = _createTextVNode(" Nenhuma mensagem encontrada "))
                    ]))
              ]))
            : _createCommentVNode("", true),
          _createVNode(Pagination, {
            "onUpdate:page": _cache[0] || (_cache[0] = (page) => reloadAndGetAll({ page })),
            "per-page": perPage.value,
            "onUpdate:perPage": _cache[1] || (_cache[1] = ($event: any) => ((perPage).value = $event)),
            data: messages.value?.pagination
          }, null, 8, ["per-page", "data"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(Dialog), {
      open: isChoiceModalOpen.value,
      "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((isChoiceModalOpen).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogScrollContent), { class: "sm:max-w-xl" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_unref(DialogTitle), { class: "text-white" }, {
                    default: _withCtx(() => _cache[63] || (_cache[63] = [
                      _createTextVNode("Escolha o tipo de disparo")
                    ])),
                    _: 1
                  }),
                  _createVNode(_unref(TooltipProvider), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Info), { class: "size-4 text-zinc-500 cursor-help" })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(TooltipContent), {
                            side: "top",
                            "side-offset": 5,
                            class: "max-w-xs bg-zinc-900 border-white/10 text-white"
                          }, {
                            default: _withCtx(() => _cache[64] || (_cache[64] = [
                              _createElementVNode("p", null, "O tipo de disparo define como a comunicação será iniciada. Fluxos permitem automações complexas, enquanto o padrão é ideal para avisos rápidos.", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_unref(DialogDescription), { class: "text-zinc-400" }, {
                  default: _withCtx(() => _cache[65] || (_cache[65] = [
                    _createTextVNode(" Selecione o formato ideal para sua campanha. ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (selectMessageType('standard'))),
                class: "flex flex-col items-center gap-4 p-8 rounded-2xl border border-white/5 bg-white/5 border-white/10 hover:border-primary/40 hover:bg-primary/[0.04] transition-all duration-300 text-center group relative overflow-hidden"
              }, [
                _cache[66] || (_cache[66] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" }, null, -1)),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_unref(MessageSquareText), { class: "size-8 text-primary" })
                ]),
                _cache[67] || (_cache[67] = _createElementVNode("div", { class: "relative z-10" }, [
                  _createElementVNode("h3", { class: "font-bold text-white text-lg" }, "Disparo Padrão"),
                  _createElementVNode("p", { class: "text-xs text-zinc-500 mt-2 leading-relaxed" }, "Mensagem direta com textos, mídias e botões de ação.")
                ], -1))
              ]),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (selectMessageType('flow'))),
                class: "flex flex-col items-center gap-4 p-8 rounded-2xl border border-white/5 bg-white/5 border-white/10 hover:border-primary/40 hover:bg-primary/[0.04] transition-all duration-300 text-center group relative overflow-hidden"
              }, [
                _cache[68] || (_cache[68] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" }, null, -1)),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_unref(GitMerge), { class: "size-8 text-primary" })
                ]),
                _cache[69] || (_cache[69] = _createElementVNode("div", { class: "relative z-10" }, [
                  _createElementVNode("h3", { class: "font-bold text-white text-lg" }, "Disparo com Fluxo"),
                  _createElementVNode("p", { class: "text-xs text-zinc-500 mt-2 leading-relaxed" }, "Acione uma automação do Chat Flow pré-configurada.")
                ], -1))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(DeleteConfirmationDialog, {
      open: isDeleteMessageDialogOpen.value,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((isDeleteMessageDialogOpen).value = $event)),
      loading: isDeletingMessage.value,
      onConfirm: _cache[6] || (_cache[6] = ($event: any) => {isDeletingMessage.value = true; _unref(destroy)(deletingMessage.value!).then(() => {
    _unref(toast)({
      title: 'Mensagem excluÃ­da com sucesso',
      class: 'bg-green-500 text-white',
      duration: 1500
    })
    isDeletingMessage.value = false
    isDeleteMessageDialogOpen.value = false
    const index = messages.value?.data.findIndex(message => message.id == deletingMessage.value)
    if (index !== -1) messages.value?.data.splice(index!, 1)
  })})
    }, null, 8, ["open", "loading"]),
    _createVNode(_unref(Dialog), {
      open: isMessageModalOpen.value,
      "onUpdate:open": _cache[54] || (_cache[54] = ($event: any) => ((isMessageModalOpen).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogScrollContent), { class: "max-w-4xl flex flex-col p-0 gap-0 bg-zinc-950 border-zinc-800" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), { class: "px-8 py-6 border-b border-zinc-800 bg-zinc-900/50" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    (!editingMessage.value)
                      ? (_openBlock(), _createBlock(_unref(Rocket), {
                          key: 0,
                          class: "size-6 text-primary"
                        }))
                      : (_openBlock(), _createBlock(_unref(PencilIcon), {
                          key: 1,
                          class: "size-6 text-primary"
                        }))
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_unref(DialogTitle), { class: "text-2xl font-bold text-white tracking-tight" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(editingMessage.value ? 'Refinar Disparo' : 'Configurar Novo Disparo'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(DialogDescription), { class: "text-zinc-400 font-medium" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(editingMessage.value ? 'Ajuste os detalhes para otimizar sua entrega.' : 'Siga os 3 passos para criar um disparo de alta conversÃ£o.'), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_unref(Stepper), {
                  modelValue: currentStep.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((currentStep).value = $event)),
                  class: "flex w-full items-start gap-4"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step) => {
                      return _createVNode(_unref(StepperItem), {
                        key: step.step,
                        class: "relative flex w-full flex-col items-center justify-center group",
                        step: step.step,
                        disabled: isStepDisabled(step.step)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(StepperTrigger), { class: "flex flex-col items-center gap-3 p-2 rounded-xl transition-all duration-300 hover:bg-white/5" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(StepperIndicator), {
                                class: _normalizeClass(["rounded-full w-12 h-12 flex items-center justify-center border-2 transition-all duration-500", [
                    step.step === currentStep.value 
                      ? 'border-primary bg-primary/20 text-primary shadow-[0_0_20px_rgba(16,185,129,0.2)]' 
                      : step.step < currentStep.value 
                        ? 'border-primary bg-primary text-black' 
                        : 'border-zinc-700 bg-zinc-900 text-zinc-500'
                  ]])
                              }, {
                                default: _withCtx(() => [
                                  (step.step < currentStep.value)
                                    ? (_openBlock(), _createBlock(_unref(Check), {
                                        key: 0,
                                        class: "size-6 stroke-[3px]"
                                      }))
                                    : (_openBlock(), _createBlock(_resolveDynamicComponent(step.icon), {
                                        key: 1,
                                        class: "size-5"
                                      }))
                                ]),
                                _: 2
                              }, 1032, ["class"]),
                              _createElementVNode("div", _hoisted_35, [
                                _createVNode(_unref(StepperTitle), {
                                  class: _normalizeClass(["text-sm font-bold tracking-wide uppercase transition-colors duration-300", [step.step === currentStep.value ? 'text-white' : 'text-zinc-500']])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(step.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class"]),
                                _createVNode(_unref(StepperDescription), {
                                  class: _normalizeClass(["text-[11px] font-medium transition-colors duration-300 hidden md:block", [step.step === currentStep.value ? 'text-zinc-400' : 'text-zinc-600']])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(step.description), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class"])
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          (step.step !== steps[steps.length - 1].step)
                            ? (_openBlock(), _createBlock(_unref(StepperSeparator), {
                                key: 0,
                                class: "absolute left-[calc(50%+3rem)] right-[calc(-50%+3rem)] top-8 h-0.5 bg-zinc-800 group-data-[state=completed]:bg-primary transition-colors duration-500 hidden sm:block"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["step", "disabled"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  (currentStep.value === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createVNode(_unref(Label), { class: "text-sm font-bold text-zinc-200 uppercase tracking-widest" }, {
                                  default: _withCtx(() => _cache[70] || (_cache[70] = [
                                    _createTextVNode("Identificação da Campanha "),
                                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_unref(TooltipProvider), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Tooltip), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(TooltipTrigger), null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(HelpCircle), { class: "size-3.5 text-zinc-600" })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(TooltipContent), null, {
                                          default: _withCtx(() => _cache[71] || (_cache[71] = [
                                            _createTextVNode("Nome usado apenas para sua organização interna.")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode(_unref(Input), {
                                modelValue: messageForm.value.description,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((messageForm.value.description) = $event)),
                                placeholder: "Ex: Oferta Relâmpago - Leads VIP",
                                class: "h-12 bg-zinc-900/50 border-zinc-700 focus:border-primary focus:ring-primary/20 transition-all text-sm"
                              }, null, 8, ["modelValue"])
                            ]),
                            (creationMode.value === 'flow')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                  _createElementVNode("div", _hoisted_44, [
                                    _createVNode(_unref(GitMerge), { class: "size-5 text-primary" }),
                                    _cache[72] || (_cache[72] = _createElementVNode("h4", { class: "font-bold text-white" }, "Automação de Fluxo", -1))
                                  ]),
                                  _cache[73] || (_cache[73] = _createElementVNode("p", { class: "text-sm text-zinc-400 leading-relaxed" }, "Selecione qual jornada o cliente iniciará ao receber esta mensagem.", -1)),
                                  _createVNode(_unref(Select), {
                                    "model-value": (messageForm.value.flowId as any),
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = v => messageForm.value.flowId = v)
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(SelectTrigger), { class: "h-12 bg-zinc-950 border-zinc-700 text-white" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(SelectValue), { placeholder: "Escolha um fluxo existente..." })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(SelectContent), { class: "bg-zinc-900 border-zinc-700" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flowsOptions.value, (f) => {
                                            return (_openBlock(), _createBlock(_unref(SelectItem), {
                                              key: f.id,
                                              value: String(f.id),
                                              class: "text-zinc-300 focus:bg-primary focus:text-black"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(f.name), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["model-value"])
                                ]))
                              : _createCommentVNode("", true),
                            (creationMode.value !== 'flow')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                  _createElementVNode("div", _hoisted_46, [
                                    _createVNode(_unref(Label), { class: "text-sm font-bold text-zinc-200 uppercase tracking-widest" }, {
                                      default: _withCtx(() => _cache[74] || (_cache[74] = [
                                        _createTextVNode("Visual & Mídia")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(AnyFileUpload, {
                                      class: "w-full",
                                      preview: startMediaPreview.value,
                                      "onUpdate:preview": _cache[10] || (_cache[10] = ($event: any) => ((startMediaPreview).value = $event)),
                                      modelValue: messageForm.value.startMedia,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((messageForm.value.startMedia) = $event)),
                                      "has-spoiler": messageForm.value.hasSpoiler,
                                      "onUpdate:hasSpoiler": _cache[12] || (_cache[12] = ($event: any) => ((messageForm.value.hasSpoiler) = $event)),
                                      label: "Arraste uma imagem ou vídeo marcante"
                                    }, null, 8, ["preview", "modelValue", "has-spoiler"])
                                  ]),
                                  _createElementVNode("div", _hoisted_47, [
                                    _createVNode(_unref(Label), { class: "text-sm font-bold text-zinc-200 uppercase tracking-widest" }, {
                                      default: _withCtx(() => _cache[75] || (_cache[75] = [
                                        _createTextVNode("Mensagem de Texto")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(RichTextarea, {
                                      modelValue: messageForm.value.message,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((messageForm.value.message) = $event)),
                                      placeholder: "Olá {{nome}}! Preparamos algo especial...",
                                      class: "min-h-[160px]",
                                      variables: [
                            { label: 'Nome', value: '{{nome}}' }
                          ]
                                    }, null, 8, ["modelValue"]),
                                    _cache[76] || (_cache[76] = _createElementVNode("p", { class: "text-[11px] text-zinc-500 font-medium" }, [
                                      _createTextVNode("Use "),
                                      _createElementVNode("code", { class: "text-primary" }, "{{nome}}"),
                                      _createTextVNode(" para personalizar com o nome do cliente.")
                                    ], -1))
                                  ]),
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, [
                                      _createVNode(_unref(Label), { class: "text-xs font-bold text-zinc-400 uppercase" }, {
                                        default: _withCtx(() => _cache[77] || (_cache[77] = [
                                          _createTextVNode("Planos")
                                        ])),
                                        _: 1
                                      }),
                                      (filteredPaymentPlans.value)
                                        ? (_openBlock(), _createBlock(_unref(TagsInput), {
                                            key: 0,
                                            class: "px-0 gap-0 w-full bg-zinc-900/50 border-zinc-700",
                                            "model-value": paymentPlanNames.value
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_50, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentPlanNames.value, (name, index) => {
                                                  return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                                    key: index,
                                                    value: name
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(TagsInputItemText), { class: "text-[10px]" }),
                                                      _createVNode(_unref(TagsInputItemDelete), {
                                                        onClick: ($event: any) => {messageForm.value.paymentPlanIds?.splice(index, 1); paymentPlanNames.value.splice(index, 1)}
                                                      }, null, 8, ["onClick"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value"]))
                                                }), 128))
                                              ]),
                                              _createVNode(_unref(ComboboxRoot), {
                                                modelValue: paymentPlanNames.value,
                                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((paymentPlanNames).value = $event)),
                                                open: isPaymentPlanComboboxOpen.value,
                                                "onUpdate:open": _cache[18] || (_cache[18] = ($event: any) => ((isPaymentPlanComboboxOpen).value = $event)),
                                                "search-term": searchPaymentPlan.value,
                                                "onUpdate:searchTerm": _cache[19] || (_cache[19] = ($event: any) => ((searchPaymentPlan).value = $event)),
                                                class: "w-full"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(ComboboxInput), {
                                                        placeholder: "+ Plano...",
                                                        "as-child": ""
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(TagsInputInput), {
                                                            onFocus: _cache[14] || (_cache[14] = ($event: any) => (isPaymentPlanComboboxOpen.value = true)),
                                                            class: _normalizeClass(["w-full px-3 h-7 bg-transparent border-none focus:ring-0 text-xs", (messageForm.value.paymentPlanIds?.length ?? 0) > 0 ? 'mt-2' : '']),
                                                            onKeydown: _cache[15] || (_cache[15] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                                          }, null, 8, ["class"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_unref(ComboboxPortal), null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(ComboboxContent), { class: "bg-zinc-900 border border-zinc-800 rounded-lg shadow-2xl p-1 z-[9999] min-w-[240px]" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(CommandList), {
                                                            position: "popper",
                                                            class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_unref(CommandEmpty), { class: "p-4 text-xs text-zinc-500" }, {
                                                                default: _withCtx(() => _cache[78] || (_cache[78] = [
                                                                  _createTextVNode("Nenhum plano encontrado")
                                                                ])),
                                                                _: 1
                                                              }),
                                                              _createVNode(_unref(CommandGroup), null, {
                                                                default: _withCtx(() => [
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPaymentPlans.value, (plan) => {
                                                                    return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                                      key: plan.id,
                                                                      value: String(plan.name),
                                                                      class: "text-xs text-zinc-300 hover:bg-zinc-800 hover:text-white cursor-pointer rounded px-3 py-2",
                                                                      onSelect: _cache[16] || (_cache[16] = _withModifiers((ev) => {
                                          if (typeof ev.detail.value === 'string') {
                                            searchPaymentPlan.value = ''
                                            const p = filteredPaymentPlans.value?.find(pp => pp.name == ev.detail.value)
                                            messageForm.value.paymentPlanIds?.push(String(p!.id))
                                            paymentPlanNames.value.push(p!.name)
                                          }
                        
                                          if (filteredPaymentPlans.value?.length === 0) {
                                            isPaymentPlanComboboxOpen.value = false
                                          }
                                        }, ["prevent"]))
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(plan.name), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["value"]))
                                                                  }), 128))
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue", "open", "search-term"])
                                            ]),
                                            _: 1
                                          }, 8, ["model-value"]))
                                        : _createCommentVNode("", true),
                                      _cache[79] || (_cache[79] = _createElementVNode("p", { class: "text-[10px] text-gray-400" }, "Você pode selecionar mais de 1 plano", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_51, [
                                      _createVNode(_unref(Label), { class: "text-xs font-bold text-zinc-400 uppercase" }, {
                                        default: _withCtx(() => _cache[80] || (_cache[80] = [
                                          _createTextVNode("Links")
                                        ])),
                                        _: 1
                                      }),
                                      (filteredButtons.value)
                                        ? (_openBlock(), _createBlock(_unref(TagsInput), {
                                            key: 0,
                                            class: "px-0 gap-0 w-full bg-zinc-900/50 border-zinc-700",
                                            "model-value": buttonNames.value
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_52, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttonNames.value, (name, index) => {
                                                  return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                                    key: index,
                                                    value: name
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(TagsInputItemText), { class: "text-[10px]" }),
                                                      _createVNode(_unref(TagsInputItemDelete), {
                                                        onClick: ($event: any) => {messageForm.value.buttonIds?.splice(index, 1); buttonNames.value.splice(index, 1)}
                                                      }, null, 8, ["onClick"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value"]))
                                                }), 128))
                                              ]),
                                              _createVNode(_unref(ComboboxRoot), {
                                                modelValue: buttonNames.value,
                                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((buttonNames).value = $event)),
                                                open: isButtonComboboxOpen.value,
                                                "onUpdate:open": _cache[24] || (_cache[24] = ($event: any) => ((isButtonComboboxOpen).value = $event)),
                                                "search-term": searchButton.value,
                                                "onUpdate:searchTerm": _cache[25] || (_cache[25] = ($event: any) => ((searchButton).value = $event)),
                                                class: "w-full"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(ComboboxInput), {
                                                        placeholder: "+ Link...",
                                                        "as-child": ""
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(TagsInputInput), {
                                                            onFocus: _cache[20] || (_cache[20] = ($event: any) => (isButtonComboboxOpen.value = true)),
                                                            class: _normalizeClass(["w-full px-3 h-7 bg-transparent border-none focus:ring-0 text-xs", (messageForm.value.buttonIds?.length ?? 0) > 0 ? 'mt-2' : '']),
                                                            onKeydown: _cache[21] || (_cache[21] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                                          }, null, 8, ["class"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_unref(ComboboxPortal), null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(ComboboxContent), { class: "bg-zinc-900 border border-zinc-800 rounded-lg shadow-2xl p-1 z-[9999] min-w-[240px]" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(CommandList), {
                                                            position: "popper",
                                                            class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_unref(CommandEmpty), { class: "p-4 text-xs text-zinc-500" }, {
                                                                default: _withCtx(() => _cache[81] || (_cache[81] = [
                                                                  _createTextVNode("Nenhum link encontrado")
                                                                ])),
                                                                _: 1
                                                              }),
                                                              _createVNode(_unref(CommandGroup), null, {
                                                                default: _withCtx(() => [
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredButtons.value, (btn) => {
                                                                    return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                                      key: btn.id,
                                                                      value: String(btn.name),
                                                                      class: "text-xs text-zinc-300 hover:bg-zinc-800 hover:text-white cursor-pointer rounded px-3 py-2",
                                                                      onSelect: _cache[22] || (_cache[22] = _withModifiers((ev) => {
                                          if (typeof ev.detail.value === 'string') {
                                            searchButton.value = ''
                                            const b = filteredButtons.value?.find(bb => bb.name == ev.detail.value)
                                            messageForm.value.buttonIds?.push(String(b!.id))
                                            buttonNames.value.push(b!.name)
                                          }
                        
                                          if (filteredButtons.value?.length === 0) {
                                            isButtonComboboxOpen.value = false
                                          }
                                        }, ["prevent"]))
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(btn.name), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["value"]))
                                                                  }), 128))
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue", "open", "search-term"])
                                            ]),
                                            _: 1
                                          }, 8, ["model-value"]))
                                        : _createCommentVNode("", true),
                                      _cache[82] || (_cache[82] = _createElementVNode("p", { class: "text-[10px] text-gray-400" }, "Você pode selecionar mais de 1 link", -1))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _cache[83] || (_cache[83] = _createElementVNode("span", { class: "text-[10px] font-bold text-zinc-500 uppercase tracking-[2px]" }, "Preview Real", -1)),
                                _createVNode(_unref(Badge), {
                                  variant: "outline",
                                  class: "text-[9px] border-zinc-800 text-zinc-500 capitalize"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(creationMode.value), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("div", _hoisted_57, [
                                  _createVNode(TelegramMessagePreview, {
                                    disableInput: true,
                                    messages: messageFormPreview.value as MessagePreviewProp[],
                                    buttons: messageForm.value.buttonIds,
                                    sender: _unref(selectedBot)?.name,
                                    class: "scale-90 origin-top h-[110%] w-[110%] -translate-x-[5%]"
                                  }, null, 8, ["messages", "buttons", "sender"])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (currentStep.value === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _cache[97] || (_cache[97] = _createElementVNode("div", { class: "text-center space-y-2" }, [
                          _createElementVNode("h3", { class: "text-2xl font-bold text-white" }, "Quem verá sua mensagem?"),
                          _createElementVNode("p", { class: "text-zinc-400 font-medium tracking-wide" }, "Escolha o público ideal para maximizar o engajamento.")
                        ], -1)),
                        _createElementVNode("div", _hoisted_59, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MessageRecipientTypeEnum), (type) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: type }, [
                              ((!_ctx.$route.query.flowId && type !== _unref(MessageRecipientTypeEnum).FLOW_NODE && type !== _unref(MessageRecipientTypeEnum).FLOW_CURRENT_NODE) || (!!_ctx.$route.query.flowId && (type === _unref(MessageRecipientTypeEnum).FLOW_NODE || type === _unref(MessageRecipientTypeEnum).FLOW_CURRENT_NODE)))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    onClick: ($event: any) => (messageForm.value.recipientType = type),
                                    class: _normalizeClass(["relative group cursor-pointer p-5 rounded-2xl border-2 transition-all duration-300 overflow-hidden", [
                        messageForm.value.recipientType === type 
                        ? 'border-primary bg-primary/5 ring-4 ring-primary/5 shadow-lg shadow-primary/10' 
                        : 'border-white/5 bg-zinc-900/50 hover:border-zinc-700'
                      ]])
                                  }, [
                                    _createElementVNode("div", _hoisted_61, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["mt-1 p-2 rounded-lg", messageForm.value.recipientType === type ? 'bg-primary text-black' : 'bg-zinc-800 text-zinc-400'])
                                      }, [
                                        _createVNode(_unref(Users), { class: "size-5" })
                                      ], 2),
                                      _createElementVNode("div", _hoisted_62, [
                                        _createElementVNode("h4", {
                                          class: _normalizeClass(["font-bold text-white tracking-wide", messageForm.value.recipientType === type ? 'text-primary' : ''])
                                        }, _toDisplayString(_unref(MessageRecipientTypeLabels)[type]), 3),
                                        _createElementVNode("p", _hoisted_63, _toDisplayString(type === _unref(MessageRecipientTypeEnum).ALL ? 'Envio para 100% da sua base de contatos.' :
                               type === _unref(MessageRecipientTypeEnum).SUBSCRIBERS ? 'Focar apenas em assinantes ativos do seu bot.' :
                               type === _unref(MessageRecipientTypeEnum).INACTIVE_SUBSCRIBERS ? 'Reative quem já comprou mas não renovou a assinatura.' :
                               type === _unref(MessageRecipientTypeEnum).DOWNSELL ? 'Recuperação automática de compras abandonadas.' :
                               type === _unref(MessageRecipientTypeEnum).CHAT_JOIN_REQUEST_APPROVAL ? 'Aprove solicitações de entrada e envie uma mensagem de boas-vindas.' :
                               'Público segmentado por critérios específicos.'), 1)
                                      ]),
                                      (messageForm.value.recipientType === type)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                            _createVNode(_unref(Check), { class: "size-6 text-primary" })
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ], 10, _hoisted_60))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]),
                        (messageForm.value.recipientType && !UNCOUNTABLE_RECIPIENT_TYPES.includes(messageForm.value.recipientType))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                              (isLoadingRecipientCount.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_unref(Loader2), { class: "size-4 animate-spin text-zinc-500" }),
                                    _cache[84] || (_cache[84] = _createElementVNode("span", { class: "text-zinc-500" }, "Calculando alcance...", -1))
                                  ], 64))
                                : (recipientCount.value !== null)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createVNode(_unref(Users), { class: "size-4 text-primary" }),
                                      _createElementVNode("span", _hoisted_66, _toDisplayString(recipientCount.value), 1),
                                      _createElementVNode("span", _hoisted_67, _toDisplayString(recipientCount.value === 1 ? 'lead será alcançado' : 'leads serão alcançados'), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (messageForm.value.recipientType === _unref(MessageRecipientTypeEnum).SUBSCRIBERS || messageForm.value.recipientType === _unref(MessageRecipientTypeEnum).ALL)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                              _cache[87] || (_cache[87] = _createElementVNode("div", { class: "flex items-center gap-2 mb-4" }, [
                                _createElementVNode("div", { class: "size-2 rounded-full bg-primary animate-pulse" }),
                                _createElementVNode("h5", { class: "text-sm font-bold text-white uppercase tracking-wider" }, "Segmentação por Planos (Opcional)")
                              ], -1)),
                              _createElementVNode("div", _hoisted_69, [
                                _createVNode(_unref(Label), { class: "text-xs font-bold text-zinc-400" }, {
                                  default: _withCtx(() => _cache[85] || (_cache[85] = [
                                    _createTextVNode("Filtrar por Planos Adquiridos")
                                  ])),
                                  _: 1
                                }),
                                (filteredTargetPaymentPlans.value)
                                  ? (_openBlock(), _createBlock(_unref(TagsInput), {
                                      key: 0,
                                      class: "px-0 gap-0 w-full bg-zinc-950 border-zinc-800",
                                      "model-value": targetPaymentPlanNames.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_70, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(targetPaymentPlanNames.value, (name, index) => {
                                            return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                              key: index,
                                              value: name,
                                              class: "bg-primary/10 text-primary border-primary/20"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(TagsInputItemText)),
                                                _createVNode(_unref(TagsInputItemDelete), {
                                                  onClick: ($event: any) => {messageForm.value.targetPaymentPlanIds?.splice(index, 1); targetPaymentPlanNames.value.splice(index, 1)}
                                                }, null, 8, ["onClick"])
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _createVNode(_unref(ComboboxRoot), {
                                          modelValue: targetPaymentPlanNames.value,
                                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((targetPaymentPlanNames).value = $event)),
                                          open: isTargetPaymentPlanComboboxOpen.value,
                                          "onUpdate:open": _cache[30] || (_cache[30] = ($event: any) => ((isTargetPaymentPlanComboboxOpen).value = $event)),
                                          "search-term": searchTargetPaymentPlan.value,
                                          "onUpdate:searchTerm": _cache[31] || (_cache[31] = ($event: any) => ((searchTargetPaymentPlan).value = $event)),
                                          class: "w-full"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(ComboboxInput), {
                                                  placeholder: "+ Adicionar Filtro de Plano...",
                                                  "as-child": ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(TagsInputInput), {
                                                      onFocus: _cache[26] || (_cache[26] = ($event: any) => (isTargetPaymentPlanComboboxOpen.value = true)),
                                                      class: _normalizeClass(["w-full px-3 h-9 bg-transparent border-none focus:ring-0 text-xs", (messageForm.value.targetPaymentPlanIds?.length ?? 0) > 0 ? 'mt-2' : '']),
                                                      onKeydown: _cache[27] || (_cache[27] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                                    }, null, 8, ["class"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_unref(ComboboxPortal), null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(ComboboxContent), { class: "bg-zinc-900 border border-zinc-800 rounded-lg shadow-2xl p-1 z-[9999] min-w-[240px]" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(CommandList), {
                                                      position: "popper",
                                                      class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_unref(CommandEmpty), { class: "p-4 text-xs text-zinc-500 text-center" }, {
                                                          default: _withCtx(() => _cache[86] || (_cache[86] = [
                                                            _createTextVNode("Planos não encontrados")
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_unref(CommandGroup), null, {
                                                          default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTargetPaymentPlans.value, (plan) => {
                                                              return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                                key: plan.id,
                                                                value: String(plan.name),
                                                                class: "text-xs text-zinc-300 hover:bg-zinc-800 hover:text-white cursor-pointer rounded px-3 py-2",
                                                                onSelect: _cache[28] || (_cache[28] = _withModifiers((ev) => {
                                    if (typeof ev.detail.value === 'string') {
                                      searchTargetPaymentPlan.value = ''
                                      const tp = filteredTargetPaymentPlans.value?.find(p => p.name == ev.detail.value)
                                      messageForm.value.targetPaymentPlanIds?.push(String(tp!.id))
                                      targetPaymentPlanNames.value.push(tp!.name)
                                    }
                  
                                    if (filteredTargetPaymentPlans.value?.length === 0) {
                                      isTargetPaymentPlanComboboxOpen.value = false
                                    }
                                  }, ["prevent"]))
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(plan.name), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["value"]))
                                                            }), 128))
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "open", "search-term"])
                                      ]),
                                      _: 1
                                    }, 8, ["model-value"]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("p", _hoisted_71, "Se nenhum plano for selecionado, o disparo atingirá todos os " + _toDisplayString(messageForm.value.recipientType === _unref(MessageRecipientTypeEnum).ALL ? 'Leads' : 'Assinantes') + ".", 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (messageForm.value.recipientType === _unref(MessageRecipientTypeEnum).DOWNSELL)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                              _cache[93] || (_cache[93] = _createElementVNode("div", { class: "flex items-center gap-2 mb-4" }, [
                                _createElementVNode("div", { class: "size-2 rounded-full bg-primary animate-pulse" }),
                                _createElementVNode("h5", { class: "text-sm font-bold text-white uppercase tracking-wider" }, "Configurações de Downsell")
                              ], -1)),
                              _createElementVNode("div", _hoisted_73, [
                                _createVNode(_unref(Label), { class: "text-xs font-bold text-zinc-400" }, {
                                  default: _withCtx(() => _cache[88] || (_cache[88] = [
                                    _createTextVNode("Gatilhos de Abandono (Planos)")
                                  ])),
                                  _: 1
                                }),
                                (filteredDownsellPaymentPlans.value)
                                  ? (_openBlock(), _createBlock(_unref(TagsInput), {
                                      key: 0,
                                      class: "px-0 gap-0 w-full bg-zinc-950 border-zinc-800",
                                      "model-value": downsellPaymentPlanNames.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_74, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(downsellPaymentPlanNames.value, (name, index) => {
                                            return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                              key: index,
                                              value: name,
                                              class: "bg-red-500/10 text-red-500 border-red-500/20"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(TagsInputItemText)),
                                                _createVNode(_unref(TagsInputItemDelete), {
                                                  onClick: ($event: any) => {messageForm.value.downsellPaymentPlanIds?.splice(index, 1); downsellPaymentPlanNames.value.splice(index, 1)}
                                                }, null, 8, ["onClick"])
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _createVNode(_unref(ComboboxRoot), {
                                          modelValue: downsellPaymentPlanNames.value,
                                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((downsellPaymentPlanNames).value = $event)),
                                          open: isDownsellPaymentPlanComboboxOpen.value,
                                          "onUpdate:open": _cache[36] || (_cache[36] = ($event: any) => ((isDownsellPaymentPlanComboboxOpen).value = $event)),
                                          "search-term": searchDownsellPaymentPlan.value,
                                          "onUpdate:searchTerm": _cache[37] || (_cache[37] = ($event: any) => ((searchDownsellPaymentPlan).value = $event)),
                                          class: "w-full"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(ComboboxInput), {
                                                  placeholder: "+ Adicionar Gatilho...",
                                                  "as-child": ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(TagsInputInput), {
                                                      onFocus: _cache[32] || (_cache[32] = ($event: any) => (isDownsellPaymentPlanComboboxOpen.value = true)),
                                                      class: _normalizeClass(["w-full px-3 h-9 bg-transparent border-none focus:ring-0 text-xs", (messageForm.value.downsellPaymentPlanIds?.length ?? 0) > 0 ? 'mt-2' : '']),
                                                      onKeydown: _cache[33] || (_cache[33] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                                    }, null, 8, ["class"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_unref(ComboboxPortal), null, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(ComboboxContent), { class: "bg-zinc-900 border border-zinc-800 rounded-lg shadow-2xl p-1 z-[9999] min-w-[240px]" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(CommandList), {
                                                      position: "popper",
                                                      class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_unref(CommandEmpty), { class: "p-4 text-xs text-zinc-500 text-center" }, {
                                                          default: _withCtx(() => _cache[89] || (_cache[89] = [
                                                            _createTextVNode("Planos não encontrados")
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_unref(CommandGroup), null, {
                                                          default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDownsellPaymentPlans.value, (plan) => {
                                                              return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                                key: plan.id,
                                                                value: String(plan.name),
                                                                class: "text-xs text-zinc-300 hover:bg-zinc-800 hover:text-white cursor-pointer rounded px-3 py-2",
                                                                onSelect: _cache[34] || (_cache[34] = _withModifiers((ev) => {
                                    if (typeof ev.detail.value === 'string') {
                                      searchDownsellPaymentPlan.value = ''
                                      const dp = filteredDownsellPaymentPlans.value?.find(p => p.name == ev.detail.value)
                                      messageForm.value.downsellPaymentPlanIds?.push(String(dp!.id))
                                      downsellPaymentPlanNames.value.push(dp!.name)
                                    }
                  
                                    if (filteredDownsellPaymentPlans.value?.length === 0) {
                                      isDownsellPaymentPlanComboboxOpen.value = false
                                    }
                                  }, ["prevent"]))
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(plan.name), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["value"]))
                                                            }), 128))
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "open", "search-term"])
                                      ]),
                                      _: 1
                                    }, 8, ["model-value"]))
                                  : _createCommentVNode("", true),
                                _cache[90] || (_cache[90] = _createElementVNode("p", { class: "text-[10px] text-gray-400" }, "Você pode selecionar mais de 1 plano", -1))
                              ]),
                              _createElementVNode("div", _hoisted_75, [
                                _createElementVNode("div", _hoisted_76, [
                                  _createVNode(_unref(Label), { class: "text-white font-bold" }, {
                                    default: _withCtx(() => _cache[91] || (_cache[91] = [
                                      _createTextVNode("Monitorar Chat Abandonado")
                                    ])),
                                    _: 1
                                  }),
                                  _cache[92] || (_cache[92] = _createElementVNode("p", { class: "text-[11px] text-zinc-500" }, "Dispara se o lead iniciou mas não interagiu pelo tempo determinado.", -1))
                                ]),
                                _createVNode(_unref(Switch), {
                                  checked: messageForm.value.abandonedChat,
                                  "onUpdate:checked": _cache[38] || (_cache[38] = ($event: any) => ((messageForm.value.abandonedChat) = $event))
                                }, null, 8, ["checked"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (messageForm.value.recipientType === _unref(MessageRecipientTypeEnum).CHAT_JOIN_REQUEST_APPROVAL)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                              _createVNode(_unref(Label), { class: "text-xs font-bold text-zinc-400 uppercase tracking-widest" }, {
                                default: _withCtx(() => _cache[94] || (_cache[94] = [
                                  _createTextVNode("Selecionar Canais ou Grupos de Monitoramento")
                                ])),
                                _: 1
                              }),
                              (groups.value)
                                ? (_openBlock(), _createBlock(_unref(TagsInput), {
                                    key: 0,
                                    class: "px-0 gap-0 w-full bg-zinc-950 border-zinc-800",
                                    "model-value": groupNames.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_78, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupNames.value, (name, index) => {
                                          return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                            key: index,
                                            value: name,
                                            class: "bg-primary/20 text-primary border-primary/20"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(TagsInputItemText)),
                                              _createVNode(_unref(TagsInputItemDelete), {
                                                onClick: ($event: any) => {messageForm.value.groupIds?.splice(index, 1); groupNames.value.splice(index, 1)}
                                              }, null, 8, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1032, ["value"]))
                                        }), 128))
                                      ]),
                                      _createVNode(_unref(ComboboxRoot), {
                                        modelValue: groupNames.value,
                                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((groupNames).value = $event)),
                                        open: isGroupComboboxOpen.value,
                                        "onUpdate:open": _cache[43] || (_cache[43] = ($event: any) => ((isGroupComboboxOpen).value = $event)),
                                        "search-term": searchGroup.value,
                                        "onUpdate:searchTerm": _cache[44] || (_cache[44] = ($event: any) => ((searchGroup).value = $event)),
                                        class: "w-full"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(ComboboxInput), {
                                                placeholder: "+ Adicionar Canal...",
                                                "as-child": ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(TagsInputInput), {
                                                    onFocus: _cache[39] || (_cache[39] = ($event: any) => (isGroupComboboxOpen.value = true)),
                                                    class: _normalizeClass(["w-full px-3 h-9 bg-transparent border-none focus:ring-0 text-xs", (messageForm.value.groupIds?.length ?? 0) > 0 ? 'mt-2' : '']),
                                                    onKeydown: _cache[40] || (_cache[40] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                                  }, null, 8, ["class"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_unref(ComboboxPortal), null, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(ComboboxContent), { class: "bg-zinc-900 border border-zinc-800 rounded-lg shadow-2xl p-1 z-[9999] min-w-[240px]" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CommandList), {
                                                    position: "popper",
                                                    class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(CommandEmpty), { class: "p-4 text-xs text-zinc-500 text-center" }, {
                                                        default: _withCtx(() => _cache[95] || (_cache[95] = [
                                                          _createTextVNode("Nenhum canal encontrado")
                                                        ])),
                                                        _: 1
                                                      }),
                                                      _createVNode(_unref(CommandGroup), null, {
                                                        default: _withCtx(() => [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGroups.value, (g) => {
                                                            return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                              key: g.id,
                                                              value: String(g.name),
                                                              class: "text-xs text-zinc-300 hover:bg-zinc-800 hover:text-white cursor-pointer rounded px-3 py-2",
                                                              onSelect: _cache[41] || (_cache[41] = _withModifiers((ev) => {
                                   if (typeof ev.detail.value === 'string') {
                                     searchGroup.value = ''
                                     const group = filteredGroups.value?.find(xxx => xxx.name == ev.detail.value)
                                     if (group && !messageForm.value.groupIds?.includes(String(group.id))) { messageForm.value.groupIds?.push(String(group.id))
                                     groupNames.value.push(group.name) }
                                   }
                 
                                   if (filteredGroups.value?.length === 0) {
                                     isGroupComboboxOpen.value = false
                                   }
                                 }, ["prevent"]))
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(g.name), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["value"]))
                                                          }), 128))
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "open", "search-term"])
                                    ]),
                                    _: 1
                                  }, 8, ["model-value"]))
                                : _createCommentVNode("", true),
                              _cache[96] || (_cache[96] = _createElementVNode("p", { class: "text-[10px] text-zinc-600 font-bold" }, "Apenas canais com aprovação automática ativa aparecerão aqui.", -1))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (currentStep.value === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                        _cache[109] || (_cache[109] = _createElementVNode("div", { class: "text-center space-y-2" }, [
                          _createElementVNode("h3", { class: "text-2xl font-bold text-white" }, "Quando disparar?"),
                          _createElementVNode("p", { class: "text-zinc-400 font-medium tracking-wide" }, "Configure o tempo perfeito para sua entrega.")
                        ], -1)),
                        (messageForm.value.recipientType === _unref(MessageRecipientTypeEnum).DOWNSELL)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                              _createElementVNode("div", _hoisted_81, [
                                _createElementVNode("div", _hoisted_82, [
                                  _createVNode(_unref(Hourglass), { class: "size-6 text-primary" }),
                                  _cache[98] || (_cache[98] = _createElementVNode("h4", { class: "font-bold text-lg text-white" }, "Delay de Recuperação", -1))
                                ]),
                                _cache[99] || (_cache[99] = _createElementVNode("p", { class: "text-sm text-zinc-400 leading-relaxed" }, "Defina quanto tempo após o abandono do checkout a mensagem deve ser enviada.", -1)),
                                _createVNode(TimePicker, {
                                  modelValue: sendingIntervalTime.value,
                                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((sendingIntervalTime).value = $event)),
                                  class: "p-4 bg-zinc-950 rounded-2xl border border-zinc-800"
                                }, null, 8, ["modelValue"])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_83, [
                              _createElementVNode("div", _hoisted_84, [
                                _createElementVNode("button", {
                                  onClick: _cache[46] || (_cache[46] = ($event: any) => (dispatchNow.value = true)),
                                  class: _normalizeClass(["p-6 rounded-2xl border-2 transition-all duration-300 flex flex-col items-center gap-2", dispatchNow.value ? 'border-primary bg-primary/10' : 'border-zinc-800 bg-zinc-900/50 hover:border-zinc-700'])
                                }, [
                                  _createVNode(_unref(Rocket), {
                                    class: _normalizeClass(["size-6", dispatchNow.value ? 'text-primary' : 'text-zinc-500'])
                                  }, null, 8, ["class"]),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["font-bold text-sm tracking-wide uppercase", dispatchNow.value ? 'text-white' : 'text-zinc-500'])
                                  }, "Imediato", 2)
                                ], 2),
                                _createElementVNode("button", {
                                  onClick: _cache[47] || (_cache[47] = ($event: any) => (dispatchNow.value = false)),
                                  class: _normalizeClass(["p-6 rounded-2xl border-2 transition-all duration-300 flex flex-col items-center gap-2", !dispatchNow.value ? 'border-primary bg-primary/10' : 'border-zinc-800 bg-zinc-900/50 hover:border-zinc-700'])
                                }, [
                                  _createVNode(_unref(CalendarIcon), {
                                    class: _normalizeClass(["size-6", !dispatchNow.value ? 'text-primary' : 'text-zinc-500'])
                                  }, null, 8, ["class"]),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["font-bold text-sm tracking-wide uppercase", !dispatchNow.value ? 'text-white' : 'text-zinc-500'])
                                  }, "Agendado", 2)
                                ], 2)
                              ]),
                              (!dispatchNow.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                    _createElementVNode("div", _hoisted_86, [
                                      _createVNode(_unref(Label), { class: "text-xs font-bold text-zinc-400 uppercase tracking-widest" }, {
                                        default: _withCtx(() => _cache[100] || (_cache[100] = [
                                          _createTextVNode("Data & Hora do Início")
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_unref(Popover), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(PopoverTrigger), { asChild: "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Button), {
                                                variant: "outline",
                                                class: "w-full h-14 bg-zinc-950 border-zinc-800 text-white font-bold justify-start rounded-xl hover:bg-zinc-800 transition-colors"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CalendarIcon), { class: "mr-3 h-5 w-5 text-primary" }),
                                                  _createTextVNode(" " + _toDisplayString(messageForm.value.sendAt ? messageForm.value.sendAt.toLocaleString('pt-BR') : 'Clique para selecionar...'), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_unref(PopoverContent), { class: "w-auto p-0 border-zinc-800 rounded-xl overflow-hidden shadow-2xl" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(CalendarTime), {
                                                mode: "single",
                                                initialFocus: "",
                                                locale: "pt-BR",
                                                selected: messageForm.value.sendAt,
                                                "onUpdate:modelValue": _cache[48] || (_cache[48] = (date) => {
                              messageForm.value.sendAt = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
                            }),
                                                "disabled-dates": { before: new Date() }
                                              }, null, 8, ["selected", "disabled-dates"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_87, [
                                      _createElementVNode("div", _hoisted_88, [
                                        _createVNode(_unref(Label), { class: "text-xs font-bold text-zinc-400 uppercase tracking-widest" }, {
                                          default: _withCtx(() => _cache[101] || (_cache[101] = [
                                            _createTextVNode("Janela Randômica")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_unref(Badge), {
                                          variant: "secondary",
                                          class: "bg-primary/20 text-primary text-[9px] uppercase border-none"
                                        }, {
                                          default: _withCtx(() => _cache[102] || (_cache[102] = [
                                            _createTextVNode("Anti-Ban")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_89, [
                                        _createElementVNode("div", _hoisted_90, [
                                          _createVNode(_unref(Input), {
                                            modelValue: messageForm.value.sendingRange,
                                            "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((messageForm.value.sendingRange) = $event)),
                                            type: "number",
                                            placeholder: "Ex: 10",
                                            class: "h-12 bg-zinc-950 border-zinc-800 text-white font-bold"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _cache[103] || (_cache[103] = _createElementVNode("span", { class: "text-zinc-500 font-bold" }, "minutos", -1))
                                      ]),
                                      _cache[104] || (_cache[104] = _createElementVNode("p", { class: "text-[10px] text-zinc-600 leading-relaxed italic" }, "Proteja sua conta: enviamos cada mensagem em intervalos variados dentro deste tempo para dificultar a detecção de spam pelo Telegram.", -1))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_91, [
                                _createElementVNode("div", _hoisted_92, [
                                  _createElementVNode("div", _hoisted_93, [
                                    _createElementVNode("div", _hoisted_94, [
                                      _createVNode(_unref(Label), { class: "text-zinc-200 font-bold" }, {
                                        default: _withCtx(() => _cache[105] || (_cache[105] = [
                                          _createTextVNode("Envio Único")
                                        ])),
                                        _: 1
                                      }),
                                      _cache[106] || (_cache[106] = _createElementVNode("p", { class: "text-[11px] text-zinc-600" }, "Desative para transformar em campanha recorrente.", -1))
                                    ]),
                                    _createVNode(_unref(Switch), {
                                      checked: dispatchOnce.value,
                                      "onUpdate:checked": _cache[50] || (_cache[50] = ($event: any) => ((dispatchOnce).value = $event))
                                    }, null, 8, ["checked"])
                                  ]),
                                  (!dispatchOnce.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                        _createVNode(_unref(Label), { class: "text-xs font-bold text-zinc-400 uppercase" }, {
                                          default: _withCtx(() => _cache[107] || (_cache[107] = [
                                            _createTextVNode("Repetir a cada")
                                          ])),
                                          _: 1
                                        }),
                                        _createElementVNode("div", _hoisted_96, [
                                          _createVNode(_unref(Input), {
                                            modelValue: messageForm.value.sendingInterval!,
                                            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((messageForm.value.sendingInterval!) = $event)),
                                            type: "number",
                                            placeholder: "7",
                                            class: "h-12 w-24 bg-zinc-900 border-zinc-800 text-center font-bold text-primary"
                                          }, null, 8, ["modelValue"]),
                                          _cache[108] || (_cache[108] = _createElementVNode("span", { class: "text-zinc-400 font-bold uppercase tracking-widest text-xs font-bold" }, "Dias Corridos", -1))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode(_unref(DialogFooter), { class: "px-8 py-6 border-t border-zinc-800 bg-zinc-900/80 flex items-center justify-between sm:justify-between w-full" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  variant: "ghost",
                  onClick: _cache[52] || (_cache[52] = ($event: any) => (currentStep.value === 1 ? closeMessageModal() : currentStep.value--)),
                  class: "h-12 px-6 text-zinc-400 hover:text-white hover:bg-white/5 font-bold transition-all"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(currentStep.value === 1 ? 'Cancelar Operação' : 'Etapa Anterior'), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_97, [
                  (currentStep.value < 3)
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 0,
                        onClick: _cache[53] || (_cache[53] = ($event: any) => (currentStep.value++)),
                        disabled: !isStepValid.value,
                        class: "h-12 px-8 bg-white text-black hover:bg-zinc-200 font-black shadow-[4px_4px_0px_0px_rgba(255,255,255,0.1)] active:translate-y-1 active:shadow-none transition-all group"
                      }, {
                        default: _withCtx(() => [
                          _cache[110] || (_cache[110] = _createTextVNode(" Próximo Passo ")),
                          _createVNode(_unref(ArrowRight), { class: "ml-2 size-4 transition-transform group-hover:translate-x-1" })
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : (_openBlock(), _createBlock(_unref(Button), {
                        key: 1,
                        onClick: save,
                        disabled: isSaving.value || !isStepValid.value,
                        class: "h-12 px-10 bg-primary text-black hover:bg-primary/90 font-black shadow-[4px_4px_0px_0px_rgba(16,185,129,0.3)] active:translate-y-1 active:shadow-none transition-all"
                      }, {
                        default: _withCtx(() => [
                          (isSaving.value)
                            ? (_openBlock(), _createBlock(_unref(Loader2), {
                                key: 0,
                                class: "mr-2 h-4 w-4 animate-spin"
                              }))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(editingMessage.value ? 'Salvar Alterações' : 'Lançar Campanha'), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_unref(Dialog), {
      open: isShowMessageDialogOpen.value,
      "onUpdate:open": _cache[55] || (_cache[55] = ($event: any) => ((isShowMessageDialogOpen).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogScrollContent), { class: "sm:max-w-2xl" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => _cache[111] || (_cache[111] = [
                    _createTextVNode("Mensagem disparada")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => _cache[112] || (_cache[112] = [
                    _createTextVNode(" Monitore as informações da sua mensagem. ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            (selectedMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    (selectedMessage.value.sentAt)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                          _createVNode(_unref(MessageSquareShare), { class: "size-5 text-primary" }),
                          _cache[113] || (_cache[113] = _createElementVNode("h6", { class: "font-semibold" }, "Disparado", -1)),
                          _createElementVNode("p", _hoisted_101, _toDisplayString(new Date(selectedMessage.value.sentAt).toLocaleString('pt-BR')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_102, [
                      _createVNode(_unref(Send), { class: "size-5 text-primary" }),
                      _cache[114] || (_cache[114] = _createElementVNode("h6", { class: "font-semibold" }, "Envios", -1)),
                      _createElementVNode("p", _hoisted_103, _toDisplayString(selectedMessage.value.successCount ?? 0), 1)
                    ]),
                    _createElementVNode("div", _hoisted_104, [
                      _createVNode(_unref(X), { class: "size-5 text-red-500" }),
                      _cache[115] || (_cache[115] = _createElementVNode("h6", { class: "font-semibold" }, "Falhas", -1)),
                      _createElementVNode("p", _hoisted_105, _toDisplayString(selectedMessage.value.failureCount ?? 0), 1)
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      _createVNode(_unref(Contact), { class: "size-5 text-primary" }),
                      _cache[116] || (_cache[116] = _createElementVNode("h6", { class: "font-semibold" }, "Destinatários", -1)),
                      _createElementVNode("div", _hoisted_107, _toDisplayString(_unref(MessageRecipientTypeLabels)[selectedMessage.value.recipientType]), 1)
                    ]),
                    (selectedMessage.value.sendingInterval?.hours)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                          _createVNode(_unref(Hourglass), { class: "size-5 text-primary" }),
                          _cache[117] || (_cache[117] = _createElementVNode("p", { class: "font-semibold" }, "Intervalo de envio", -1)),
                          _createElementVNode("p", _hoisted_109, _toDisplayString(_unref(formatInterval)(selectedMessage.value.sendingInterval)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (selectedMessage.value.sendingRange?.minutes)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                          _createVNode(_unref(Hourglass), { class: "size-5 text-primary" }),
                          _cache[118] || (_cache[118] = _createElementVNode("p", { class: "font-semibold" }, "Janela de envio", -1)),
                          _createElementVNode("p", _hoisted_111, _toDisplayString(selectedMessage.value.sendingRange.minutes) + "m", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(TelegramMessagePreview, {
                    class: "col-span-full",
                    messages: previewMessages.value,
                    sender: _unref(selectedBot)?.name
                  }, null, 8, ["messages", "sender"])
                ]))
              : (_openBlock(), _createBlock(_unref(Loader2), {
                  key: 1,
                  class: "w-10 h-10 animate-spin text-white mx-auto"
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})